export default {
    BLANK: 'Blank',
    DOT: 'Dot',
    RECTANGLE: 'Rectangle'
}